import React from 'react';
import {useSelector} from "react-redux";

import styles from './OffersLayoutBanner.module.scss';

export default function OffersLayoutBanner ({
    packId,
    highlightedBanner,
    highlightedBannerMobile,
    image,
    priceFormatted,
    popUpImg,
    selectOfferById,
    openPopupInfo,
    endTime,
    categoryId,
    noTimers,
    isFree,
    isClaimed
}) {
    const {windowSize} = useSelector((state) => state.rootReducer);
	const id = packId;

  return (
	<div
		className={styles.offerWrapper}
		onClick={() => popUpImg && openPopupInfo ?
			openPopupInfo({
				img: popUpImg,
				id: id,
				categoryId: categoryId,
				price: priceFormatted,
				isFree: isFree,
				isClaimed: isClaimed
			})
		:
			selectOfferById(id, categoryId)
		}
	>
		<img className={styles.bannerImg} src={windowSize.isMobileView ? highlightedBannerMobile : highlightedBanner} alt='' />
	</div>
  );
};